<template>
    <div name="introduction" class="introduction" id="introduction">
        <div class="container">
            <div class="section-header">
                <strong class="title">바로돌봄을 소개합니다</strong>
                <p class="sub-text">스스로 의료 활동 신청이 어려운 의료취약계층을<br> 위한 <strong>국내 유일 비대면진료 솔루션</strong>입니다.<br>
                    정신병원, 요양원, 주야간돌봄센터 등 어르신을<br> 케어하는 기관에 도입할 수 있습니다.</p>
            </div>
            <div class="card-area">
                <ul class="card-list">
                    <li>
                        <div class="card-title">
                            <strong>주 야간 돌봄 센터</strong>
                            <span>보호자 없이 내원이 어려운 어르신</span>
                        </div>
                        <img class="img-card" src="../../assets/mobile_barocare/img_care_center.jpg" alt="보호자 없이 내원이 어려운 어르신">
                    </li>
                    <li>
                        <div class="card-title">
                            <strong>요양원</strong>
                            <span>거동이 불편한 환자 또는 어르신</span>
                        </div>
                        <img class="img-card" src="../../assets/mobile_barocare/img_sanatorium.jpg" alt="거동이 불편한 환자 또는 어르신">
                    </li>
                    <li>
                        <div class="card-title">
                            <strong>정신병원</strong>
                            <span>내원이 자유롭지 않은 정신 질환 환자</span>
                        </div>
                        <img class="img-card" src="../../assets/mobile_barocare/img_mental_barocare.jpg" alt="내원이 자유롭지 않은 정신 질환 환자">
                    </li>
                </ul>
                <div class="btn-area">
                    <a href="../../2401_soldoc_바로돌봄_서비스소개자료.pdf" class="btn-download" download>소개서 다운로드</a>
                </div>
            </div>
        </div>
        <div class="container cont2">
            <div class="section-header">
                <strong class="title">바로돌봄을 통해</strong>
                <p class="sub-text">기관 임직원분들의 간단한 도움으로<br>
                    환자가 전문 의료진을 쉽게 만나볼 수 있습니다</p>
                <div class="graph-area">
                    <span class="item">환자</span>
                    <span class="center">바로돌봄 서비스</span>
                    <span class="item">의사</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'introduction',
    mounted: function()
    {

    },
    methods: {
    
    }
}
</script>

<style scoped>
    .introduction {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        /* height: 720px; */
        background: #fff;
    }
    .introduction:before{
        position: absolute;
        top: 1503px;
        content: '';
        display: block;
        width: 100%;
        height: calc(100% - 1503px);
        background: #F6F6F6;
    }
    .introduction .container{
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        margin: 0 auto;
        padding: 147px 20px 40px;
        z-index: 2;
    }
    .section-header{
        width: 100%;
        font-family: 'Pretendard';
        text-align: center;
    }
    .section-header .title{
        font-size: 32px;
        font-weight: 600;
        line-height: 1.4;
        color: #1A1A1A;
    }
    .section-header .sub-text{
        margin: 16px -7px 0;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.66;
        color: #1A1A1A;
    }
    .sub-text strong{
        font-weight: 600;
    }
    .card-area{
        width: 100%;
        margin-top: 57px;
    }
    .card-list{
        display: flex;
        flex-direction: column;
        gap: 20px;
        width: 100%;
        margin-bottom: 20px;
        padding: 0;
        list-style-type: none;
        animation: fadeInUp1 2s;
    }
    .card-list li{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        gap: 37px;
        width: 100%;
        height: 450px;
        background: #fff;
        border: 1px solid #CCC;
        border-radius: 10px;
        overflow: hidden;
        box-sizing: border-box;

        font-family: 'Pretendard';
        font-style: normal;
        text-align: center;
        color: #1A1A1A;
    }
    .card-title{
        display: flex;
        flex-direction: column;
        margin-bottom: 0;
        padding: 33px 33px 0;
    }
    .card-list strong{
        /* padding: 33px 33px 0; */
        font-size: 24px;
        font-weight: 600;
        line-height: 1.2;
    }
    .card-list span{
        margin-top: 7px;
        font-size: 18px;
        font-weight: 400;
    }
    .card-list .img-card{
        width: 100%;
        /* margin-top: 37px; */
    }

    .introduction .cont2{
        width: 100%;
        margin: 0 auto;
        padding: 75px 20px 533px;
        background: #F6F6F6;
        z-index: 1;
    }

    .cont2:before{
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        content: '';
        display: block;
        width: 100%;
        height: 800.5px;
        background: url(../../assets/mobile_barocare/bg-introduction@2x.png) no-repeat;
        background-position: center center;
        background-size: 512px auto;
        background-size: auto 800.5px;
        z-index: -1;
    }
    .cont2 .section-header{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .graph-area{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 348px;
        height: 64px;
        margin-top: 49px;
    }
    .graph-area .item{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        background: #FFF;
        border: 1px solid #999;
        border-radius: 64px;
        font-size: 16px;
        font-weight: 400;
        color: #999;
    }
    .graph-area .center{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 172px;
        height: 64px;
        background: #0082EC;
        border: 1px solid #0082EC;
        border-radius: 96px;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
    }
    .graph-area .center::after{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        content: '';
        display: block;
        width: 226px;
        height: 6px;
        background: url(../../assets/mobile_barocare/bg-graph-line.png) no-repeat;
        background-position: center center;
        background-size: 226px auto;
    }

    .btn-download{
        display: inline-flex;
        min-height: 50px;
        width: 100%;
        margin-bottom: 35px;
        padding: 9px 0;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        border: 1px solid #fff;
        background: #0082EC;
        color: #FFF;
        text-align: center;
        font-size: 18px;
        font-family: 'Pretendard';
        font-weight: 600;
        line-height: 1.3;
        cursor: pointer;
        text-decoration: none; 
        animation: fadeInUp1 2s;
    }
    .btn-download:hover{
        background: #FFF;
        color: #0082EC;
        font-weight: 600;
        text-decoration: none; 
    }

    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/Introduction.vue